import { render, staticRenderFns } from "./AddSireModal.vue?vue&type=template&id=5d31a686"
import script from "./AddSireModal.vue?vue&type=script&lang=ts"
export * from "./AddSireModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports